module.exports = __webpack_public_path__ + "img/live_on.cc096fe6.png";